import type { RouteObject } from 'react-router';

import { personvelgerLoader } from '../../router/loader';
import ErrorElement from '../error';
import Personvelger from './personvelger';

export const routes: RouteObject[] = [
  {
    path: '*',
    loader: personvelgerLoader,
    element: <Personvelger />,
    errorElement: <ErrorElement />,
  },
];
